export default "__VITE_ASSET__C_l0TvKp__"